import api from '../services/api';
import { $Q, $Qll } from '../utils/query-selector';
import { stringToHTML } from '../utils/to-html';
import { dataToggle, toggleDataActive } from '../utils/toggle-dataset';

/**
 * Delay function
 *
 * @param {Function} fn - Function that you want a delay execution
 * @param {Number} wait - This time delay (ms)
 * @returns Function delay
 */
function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

/**
 * Init script Predictive search
 */
export const mountPredictiveSearch = () => {
  // ? event toggle icon search - show input search

  $Q('.search-js').addEventListener('click', () => {
    const state = dataToggle($Q('#search-predictive'), true, false);

    if (state) {
      const element = $Q('#Search');
      element.scrollIntoView();
      element.focus();
    }
  });

  // ? event change input search
  const searchInputs = $Qll("input[type='search']");
  searchInputs.forEach((input) => {
    input.addEventListener(
      'input',
      debounce((event) => {
        onChangePredictive(event);
      }, 300).bind(this)
    );
  });
};

/**
 *
 * @param {Event} event - event input change in field search
 * if is text letter is open and execute query fetch api, else close suggest
 */
const onChangePredictive = (event) => {
  const searchTerm = event.target.value.trim();

  if (!searchTerm.length) {
    close(event.target);
    return;
  }

  // > Search
  console.log('search_bar_interaction');
  dataLayer.push({
    event: 'search_bar_interaction',
    search_query: searchTerm,
  });

  open(event.target);
  elementListContainer(event.target).innerHTML = `
    <div class="loading-container">
      <div id='loading'></div>
    <div>`;
  setTimeout(() => {
    getSearchResults(searchTerm, event.target);
  }, 100);
};

/**
 * get list result for query api.
 * @param {String} searchTerm - query search
 */
const getSearchResults = async (searchTerm, parent) => {
  // ? params custom search (customize in snippet "predictive-search")
  const limitSearch =
    parent.closest('#search-predictive').dataset.configLimit || 5;
  const paramsSearch =
    parent.closest('#search-predictive').dataset.configParams || 'product';
  const fieldsSearch =
    'title,product_type,variants.title,variants.sku,body,tag,variants.barcode,vendor';
  const base = `${routes.predictive_search_url}?q=${searchTerm}&resources[type]=${paramsSearch}&resources[limit]=${limitSearch}&resources[options][fields]=${fieldsSearch}`;
  const result = await api.shopifySectionByUrl(
    base,
    'predictive-search',
    '&section_id'
  );
  const listItems = $Q('#predictive-search-results', stringToHTML(result));
  // ? add element result in container list predictive
  elementListContainer(parent).innerHTML = listItems.outerHTML;
};

const open = (parent) => {
  elementListContainer(parent).style.display = 'block';
};

const close = (parent) => {
  elementListContainer(parent).style.display = 'none';
};

const elementListContainer = (parent) =>
  $Q('#predictive-search-list', parent.closest('form'));
